import { render } from "./Inventory_data_delete_button.vue?vue&type=template&id=e931cf54&scoped=true"
import script from "./Inventory_data_delete_button.vue?vue&type=script&lang=js"
export * from "./Inventory_data_delete_button.vue?vue&type=script&lang=js"

import "./Inventory_data_delete_button.vue?vue&type=style&index=0&id=e931cf54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e931cf54"]])

export default __exports__